import React from 'react';
import TitleText from '../../../../Components/TitleText/TitleText';
import './AboutUs.css'


const AboutUs = () => {
    return (
        <div id="about" data-aos="fade-in" data-aos-duration="3000" className="container ">

            <div className="row justify-content-md-center  ">


                <div className="col-md-12 col-sm-12 col-lg-6 ">
                    <TitleText title1="About" title2="us" position="center" />
                    <p className='aboutPara'><b>LIMIT DESIGNERS</b> is an <b>Architecture</b> and <b>Civil Engineering</b> Company. The company is run by multidisciplinary management, who has 10+ years of experience in interior and Civil Construction design and execution, managing supply chains and procurement, business operations and customer services. The result is an extremely smooth timely project execution where all the nodes of the process are owned by teams of through professionals. We pride our selves of being a part of a company which is on <b>Commitment, Culture and Innovation.</b></p>
                </div>
                <div className="col-md-12 col-sm-12 col-lg-6 mt-5">
                    <img className='aboutImg' src='https://webredox.net/demo/wp/bauen/light/el/multi/demo1/wp-content/uploads/2021/09/about.jpg' alt="" />
                    <p className='office'>OFFICE</p>

                </div>

            </div>
        </div >
    );
};

export default AboutUs;